import { render, staticRenderFns } from "./CreateCardFootbar.vue?vue&type=template&id=1f5f44cd"
import script from "./CreateCardFootbar.vue?vue&type=script&lang=js"
export * from "./CreateCardFootbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports